import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const DiagnosticService = {
  async createDiagnostic(payload) {
    const res = await axios.post('org/v1/salyk/cabinet/getData/', payload);

    if (res.status === 200) {
      return res;
    }

    return Promise.reject();
  },

  async saveDiagnostic(payload) {
    const res = await axios.post('org/v1/salyk/cabinet/saveData/', payload);

    if (res.status === 201) {
      return res;
    }

    return Promise.reject();
  },

  async getDiagnostic(page, perPage) {
    const params = generateQueryParams({
      page,
      size: perPage,
    });

    const res = await axios.get(`org/v1/salyk/cabinet/diagnostics/`, {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async getPDF(data) {
    const res = await axios.post(
      `/salyk/cabinet/toPDF/`,
      {
        html: data,
      },
      {
        responseType: 'arraybuffer',
      }
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
